import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { createUserUrl } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { UserCreateRequest } from "../../domain/user";
import { convertFormData } from "@/business/shared/commons/rest/convertToFormData";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const createUserService = {
  async execute(
    token: string,
    createUserRequest: UserCreateRequest
  ): Promise<void> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(createUserUrl);

    const headers = {
      "web-token": token,
      Accept: "application/json",
    };

    const formData = convertFormData(createUserRequest);

    const response: RestResponse = await restClient().sendRequest(
      url,
      "POST",
      formData,
      headers
    );

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }
  },
};
